
// import libs
// import cookieBar from './libs/cookieBar';
import { CountUp } from './libs/CountUp.js';

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
import './components/ie-edge-detection.js';
import './components/menu.js';
import './components/filter.js';
import './components/modal.js';

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
// function throttle (callback, limit) {
//   var wait = false;
//   return function () {
//     if (!wait) {
//       callback.apply(null, arguments);
//       wait = true;
//       setTimeout(function () {
//         wait = false;
//       }, limit);
//     }
//   }
// }

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
// function debounce(func, wait, immediate) {
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };

// init
// cookieBar.init({
//   // settings
//   infoText: 'Soubory cookies nám pomáhají poskytovat, chránit a zlepšovat naše služby. Prohlížením tohoto webu s jejich používáním souhlasíte.',
//   buttonText: 'Rozumím',
//   ipCheck: false,
// });

// $('.lazy').Lazy({
//   // your configuration goes here
//   scrollDirection: 'vertical',
//   effect: 'fadeIn',
//   effectTime: 150,
//   visibleOnly: false,
//   threshold: 500,
//   lazyLoad: 'ondemand',
//   bind: 'event',
//   onError: function(element) {
//       console.log('error loading ' + element.data('src'));
//   }
// });

// AOS animations
AOS.init({disable: 'mobile', once: true});  

// Parallax
// $(window).ready(function() {
//   $('.parallax').paroller();
//   // console.log($('.parallax'));
//   // $(".paroller").paroller({ factor: '-1', type: 'foreground', direction: 'horizontal' });
// });

// ----------------------------------------
//  scroll to
function scrollTo(e) {

  var href = $.attr(this, 'href');
  if (typeof href === 'undefined') {
      href = $.attr(this, 'data-href');
  }
  href = href.replace('/', '');
  var offset = $.attr(this, 'data-offset');

  var $target = $(href);
  headerHeight = 0;
  if ($target.length) {
      e.preventDefault();    
      $('html,body').animate({
        scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 10)
      }, {
        duration: 500,
        easing: 'swing'
      });
  }
}
$('.scrollTo, .menu-item-type-custom a').on('click', scrollTo);

// ----------------------------------------

// scripts here

// bounce rate event
// var stayOnPage = 10000;
// setTimeout(function(e) {
//   var label = 'na webu alespoň ' + (stayOnPage / 1000) + 's';
//   gtag('event', 'bounce rate fix', {'event_category': 'navstevnik','event_label': label});
// }, stayOnPage);


// redirect to thankyou page
document.addEventListener( 'wpcf7mailsent', function( event ) {
  location = '/dekujeme';
  console.log('formular byl odeslán');
}, false );

$('.carousel--news').slick({
  // lazyLoad: 'ondemand',
  slidesToShow: 3,
  slidesToScroll: 1,
  // autoplay: false,
  // autoplaySpeed: 2000,
  arrows: true,
  dots: true,
  centerMode: false,
  // centerPadding: '0px',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
        slidesToShow: 2,
        // slidesToScroll: 1,
      }
    },
    {
      breakpoint: 576,
      settings: {
        arrows: false,
        slidesToShow: 1,
        // slidesToScroll: 1,
      }
    },
  ],
});

$('.carousel--topics').slick({
  // lazyLoad: 'ondemand',
  slidesToShow: 3,
  slidesToScroll: 1,
  // autoplay: false,
  // autoplaySpeed: 2000,
  arrows: true,
  dots: true,
  centerMode: false,
  // centerPadding: '0px',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        // arrows: true,
        slidesToShow: 1,
        // slidesToScroll: 1,
      }
    },
  ],
});

// $('#testimonials').slick({
//   // lazyLoad: 'ondemand',
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   // autoplay: false,
//   // autoplaySpeed: 3000,
//   arrows: true,
//   dots: false,
//   centerMode: false,
//   // centerPadding: '0px',
//   adaptiveHeight: true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         // arrows: true,
//         slidesToShow: 1,
//         // slidesToScroll: 1,
//         adaptiveHeight: true,
//       }
//     },
//   ],
// });

// $('#productsCarousel').slick({
//   // lazyLoad: 'ondemand',
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   // autoplay: false,
//   // autoplaySpeed: 3000,
//   arrows: true,
//   dots: false,
//   centerMode: false,
//   // centerPadding: '0px',
//   adaptiveHeight: true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         // arrows: true,
//         slidesToShow: 1,
//         // slidesToScroll: 1,,
//         adaptiveHeight: true,
//       }
//     },
//     // {
//     //   breakpoint: 576,
//     //   settings: {
//     //     // arrows: true,
//     //     slidesToShow: 1,
//     //   }
//     // },
//   ],
// });

// $('#recipesCarousel').slick({
//   // lazyLoad: 'ondemand',
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   // autoplay: false,
//   // autoplaySpeed: 3000,
//   arrows: true,
//   dots: false,
//   centerMode: false,
//   // centerPadding: '0px',
//   adaptiveHeight: true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         // arrows: true,
//         slidesToShow: 2,
//         // slidesToScroll: 1,
//       }
//     },
//     {
//       breakpoint: 576,
//       settings: {
//         // arrows: true,
//         slidesToShow: 1,
//         // slidesToScroll: 1,
//         adaptiveHeight: true,
//       }
//     },
//   ],
// });


// $('#showAllProducts').on('click', function(e) {
//   $('.product').removeClass('d-none');
//   $(this).addClass('d-none');
// });

// $('#showAllRecipes').on('click', function(e) {
//   $('.recipes').find('.recipe').removeClass('d-none2');
//   $(this).addClass('d-none');
// });

// $('#showAllRecipes2').on('click', function(e) {
//   $('#recipesListOthers').find('.recipesList__item').removeClass('d-none2');
//   $(this).addClass('d-none');
// });

// var waypointsFilter = $('#productsList').waypoint({
//   handler: function(direction) {
    
//     if (direction == 'down') {
//       $('#productFilterSticky').addClass('show');
//       // console.log('show');
//     }

//     if (direction == 'up') {
//       // console.log('hide');
//       $('#productFilterSticky').removeClass('show');
//     }

//   }
// }, {
//   offset: '0%'
// });


// var waypoints = $('#o-nas').waypoint(function(direction) {
//   numbers(true);
//   this.destroy();
// }, {
//   offset: '35%'
// });

// function numbers(canAnimated) {
//   // numbers
//   var objs = [];
//   var $numbers = $('.animatedNumber');
//   for (var i = 0; i < $numbers.length; i++) {
//     var id = $($numbers[i]).attr('id');
//     var val = parseFloat($($numbers[i]).attr('data-value'));
//     console.log(val);
//     var duration = parseInt($($numbers[i]).attr('data-duration'));
//     var delay = parseInt($($numbers[i]).attr('data-delay'));

//     objs.push(new CountUp(id, val, {
//       decimalPlaces: ($($numbers[i]).hasClass('animatedNumber--float') ? 2 : 0),
//       duration: (canAnimated) ? duration / 1000 : 0,
//       separator: '',
//       delay: (canAnimated) ? delay : 0,
//     }));
//   }

//   // console.log(objs);

//   // first number
//   setTimeout(function(e) {    
//     objs[0].start(function(e) {      
//       $(this.el).addClass('done');
//     });
//   }, objs[0].options.delay);

//   // second number
//   setTimeout(function(e) {
//   	objs[1].start(function(e) {
//   		$(this.el).addClass('done');
//   	});
//   }, objs[1].options.delay);

//   // third number
//   setTimeout(function(e) {
//   	objs[2].start(function(e) {
//   		$(this.el).addClass('done');
//   	});
//   }, objs[2].options.delay);
// }